
<div class="page-header">
    <a routerLink="/reviews/overzicht" class="page-header__back">
        <i class="fa-regular fa-chevron-left"></i>
    </a>
    <h1 class="page-header__title">{{ "reviews.title" | translate }}</h1>
    <div class="page-header__actions"></div>
</div>

<app-review-detail-form [review]="review$ | async" [activityTypes]="activityTypes$ | async" (submitted)="submit($event)" [errors]="errors$ | async" [loading]="loading$ | async"/>